var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"img-container"},[(_vm.languages.lan==='cn')?_c('img',{attrs:{"src":require("assets/pics/ServiceCenterCn.png"),"alt":""}}):_c('img',{attrs:{"src":require("assets/pics/ServiceCenterEn.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }